import { deduplicateEmails, validateEmail } from '@/utils/emailValidation';

export const PRICELIST_CASE_NOTIFY_EMAIL_LIMIT = 20;

export function parseNotifyEmailDraft(raw: string): string | null {
  const email = raw.trim().toLowerCase();
  if (email.length === 0) return null;
  return validateEmail(email) ? email : null;
}

export function addNotifyEmail(
  current: readonly string[],
  raw: string,
): { emails: string[] } | { error: 'invalid' | 'duplicate' | 'limit' } {
  const email = parseNotifyEmailDraft(raw);
  if (email === null) return { error: 'invalid' };
  const existing = new Set(current.map((value) => value.toLowerCase()));
  if (existing.has(email)) return { error: 'duplicate' };
  if (current.length >= PRICELIST_CASE_NOTIFY_EMAIL_LIMIT) {
    return { error: 'limit' };
  }
  return { emails: deduplicateEmails([...current, email]) };
}

export function removeNotifyEmail(
  current: readonly string[],
  email: string,
): string[] {
  const target = email.toLowerCase();
  return current.filter((value) => value.toLowerCase() !== target);
}
